var map = {
	"./chair-1-seat-1-back.webp": 341,
	"./loveseat-1-seat-1-back.webp": 342,
	"./loveseat-1-seat-2-back.webp": 343,
	"./loveseat-2-seat-1-back.webp": 344,
	"./loveseat-2-seat-2-back.webp": 345,
	"./ottoman-1-seat.webp": 346,
	"./sofa-1-seat-1-back.webp": 347,
	"./sofa-1-seat-2-back.webp": 348,
	"./sofa-1-seat-3-back.webp": 349,
	"./sofa-2-seat-1-back.webp": 350,
	"./sofa-2-seat-2-back.webp": 351,
	"./sofa-3-seat-1-back.webp": 352,
	"./sofa-3-seat-3-back.webp": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 340;